import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class Services extends Component {
  render() {
    let data = [
  {
    pageLink: "early-intervention",
    img: "service1.jpg",
    iconClass: "fa fa-child",
    serviceTitle: "Early Intervention & Child Development",
    serviceSubtitle:
      "Supporting young children through early intervention to promote physical, cognitive, language, social, and emotional development."
  },
  {
    pageLink: "play-language-therapy",
    img: "service2.jpg",
    iconClass: "fa fa-comments",
    serviceTitle: "Play & Language Therapy",
    serviceSubtitle:
      "Play and language therapy use play-based activities and structured communication exercises to improve children’s speech, language, social, emotional, and cognitive skills, promoting overall development and effective communication."
  },
  {
    pageLink: "social-communication",
    img: "service3.jpg",
    iconClass: "fa fa-users",
    serviceTitle: "Social Communication & Behaviour Modification",
    serviceSubtitle:
      "Helping children develop effective communication, positive behaviour, social skills, emotional regulation, and confidence through evidence-based interventions that support success at home, school, and in the community."
  },
  {
    pageLink: "speech-therapy",
    img: "service4.jpg",
    iconClass: "fa fa-microphone",
    serviceTitle: "Speech Therapy",
    serviceSubtitle:
      "Speech Therapy helps children develop clear speech, effective communication, language understanding, and confidence through individualized interventions that support learning, social interaction, and successful participation in everyday activities."
  },
  {
    pageLink: "special-education",
    img: "service5.jpg",
    iconClass: "fa fa-graduation-cap",
    serviceTitle: "Special Education",
    serviceSubtitle:
      "At Shakuntla Learn and Fly Foundation, we provide individualized Special Education programs that empower children with diverse learning needs to achieve academic success, independence, confidence, and lifelong growth."
  },
  {
    pageLink: "learning-support",
    img: "service6.jpg",
    iconClass: "fa fa-book",
    serviceTitle: "Learning Support",
    serviceSubtitle:
      "Helping children overcome learning challenges through personalized educational support, building academic skills, confidence, independence, and a positive attitude towards lifelong learning."
  },
  {
    pageLink: "occupational-therapy",
    img: "service7.jpg",
    iconClass: "fa fa-hand-paper-o",
    serviceTitle: "Occupational Therapy",
    serviceSubtitle:
      "Helping children develop the skills needed for everyday activities by improving motor abilities, sensory processing, coordination, independence, and confidence through individualized, evidence-based therapeutic interventions."
  },
  {
    pageLink: "parent-counselling",
    img: "service8.jpg",
    iconClass: "fa fa-user-circle",
    serviceTitle: "Parent Counselling & Guidance",
    serviceSubtitle:
      "Supporting parents with professional guidance, practical strategies, and emotional support to better understand their child’s needs, strengthen family relationships, and promote positive developmental outcomes."
  },
  {
    pageLink: "holistic-child-development",
    img: "service9.jpg",
    iconClass: "fa fa-heart",
    serviceTitle: "Holistic Child Development",
    serviceSubtitle:
      "Nurturing every aspect of a child’s growth through integrated programs that support cognitive, physical, emotional, social, communication, and life skills for overall development and lifelong success."
  },
  {
    pageLink: "sports-program-development",
    img: "service10.jpg",
    iconClass: "fa fa-futbol-o",
    serviceTitle: "Sports Programs for Development",
    serviceSubtitle:
      "Promoting physical fitness, teamwork, confidence, coordination, discipline, and social development through structured sports activities that inspire children to lead active, healthy, and confident lives."
  }
];

    let Datalist = data.map((val, i) => {
      return (
        <div
          className="col-lg-4 col-md-6 col-12 section-space--bottom--30"
          key={i}
        >
          <div className="service-grid-item">
            <div className="service-grid-item__image">
              <div className="service-grid-item__image-wrapper">
                <a href={`${process.env.PUBLIC_URL}/${val.pageLink}`}>
                  <img
                    src={`assets/img/service/${val.img}`}
                    className="img-fluid"
                    alt="Service Grid"
                  />
                </a>
              </div>
              <div className="icon">
                <i className={val.iconClass} />
              </div>
            </div>
            <div className="service-grid-item__content">
              <h3 className="title">
                <a href={`${process.env.PUBLIC_URL}/${val.pageLink}`}>
                  {val.serviceTitle}
                </a>
              </h3>
              <p className="subtitle">{val.serviceSubtitle}</p>
             
            </div>
          </div>
        </div>
      );
    });

    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Service</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>Service</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        {/*====================  service page content ====================*/}
        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="service-item-wrapper">
                    <div className="row">{Datalist}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/*====================  End of service page content  ====================*/}


        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default Services;
